import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

export function TableHeadCell({ className, width, highlight, alignRight, clickable, ...props }) {
  return (
    <th
      className={classNames(
        styles.table_header,
        highlight && styles.table_header__highlight,
        alignRight && styles.table_header__align_right,
        clickable && styles.table_header__clickable,
        className,
      )}
      width={width}
      {...props}
    />
  );
}

TableHeadCell.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  highlight: PropTypes.bool,
  alignRight: PropTypes.bool,
  clickable: PropTypes.bool,
};
